// extracted by mini-css-extract-plugin
export default {"card":"CompleteProfileCard_card__FKR6b","iconWrapper":"CompleteProfileCard_iconWrapper__VHanj","content":"CompleteProfileCard_content__xoiYT"};